var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPack = function SvgPack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4 12.6c-.1-.2-.3-.4-.6-.4h-3.7V3.5c0-.4-.3-.7-.7-.7h-7.2c-.3 0-.7.3-.7.7v8.7h-3.7c-.2 0-.5.2-.6.4-.1.2-.1.5.1.7l8 9.3c.1.1.3.2.5.2s.4-.1.5-.2l8-9.3c.2-.2.3-.5.1-.7zm-8.6 8.5-6.6-7.6h2.9c.4 0 .7-.3.7-.7V4.1h5.9v8.7c0 .4.3.7.7.7h2.9l-6.5 7.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26.3 40.2 21c-.1-.1-.2-.1-.2-.2h-.1l-9.1-2.6-1 1.1 7.4 2.1-13.5 3.8-13.5-3.8 7.4-2.1-1-1.1-9.1 2.6c-.1 0-.2.1-.2.2l-4.8 5.3c-.1.2-.2.4-.1.6.1.2.2.4.4.5l4.3 1.5v10c0 .3.2.5.4.6l15.9 6h.4l15.9-6c.3-.1.4-.4.4-.6v-10l4.3-1.5c.2-.1.4-.2.4-.5.4-.3.3-.5.2-.6zm-40.7.1 3.8-4.3 14.5 4.1-3.9 5.1-14.4-4.9zm18.9 17.5L8.6 38.4v-9.1l10.2 3.5h.2c.2 0 .4-.1.5-.3l3.6-4.7v16.1zm15.9-5.5-14.6 5.5v-16l3.6 4.7c.1.2.3.3.5.3h.2l10.3-3.5v9zm-10.3-7-3.9-5.1 14.6-4.1 3.8 4.3-14.5 4.9z"
  })));
};
export default SvgPack;